import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Train } from '../../models/train.model';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/_service/appconfigservice';
import { Warrantycondition } from 'src/app/models/warrantycondition.model';
@Injectable({
  providedIn: 'root',
})
export class warrantyconditionService {
  gnBaseURL: any;
  constructor(private http: HttpClient, private appURL: AppConfigService) {
    this.gnBaseURL = this.appURL.getServerUrl();
  }
  
  getwarrantiesByTrainId(id: string): Observable<Warrantycondition[]> {
    return this.http.get<Warrantycondition[]>(
      this.gnBaseURL + 'Warranty/GetwarrantiesByTrainId/' + id
    );
  }

  getwarrantiesById(id: string): Observable<Warrantycondition> {
    return this.http.get<Warrantycondition>(
      this.gnBaseURL + 'Warranty/GetWarrantiesById/' + id
    );
  }

  addWarranty(
    addWarrantyRequest: Warrantycondition
  ): Observable<Warrantycondition> {
    console.log(addWarrantyRequest);
    return this.http.post<Warrantycondition>(
      this.gnBaseURL + 'Warranty/AddWarranty',
      addWarrantyRequest
    );
  }

  updateWarranty(
    id: number,
    model: Warrantycondition
  ): Observable<Warrantycondition> {
    return this.http.post<Warrantycondition>(
      this.gnBaseURL + 'Warranty/EditWarranty/' + id,
      model
    );
  }

  deleteWarranty(Id: number) {
    return this.http.get(
      this.gnBaseURL + 'Warranty/' + Id + '/action/delete'
    );
  }
}
